const SELLER_REGISTRATION_SHORT_QUERY_PARAM = 'v'
const SELLER_REGISTRATION_LEGACY_QUERY_PARAM = 'vendedor'
const SELLER_REGISTRATION_STORAGE_KEY = 'flexi.storefront.seller-registration-token'
const SELLER_REGISTRATION_SIGNED_TOKEN_PATTERN = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/
const SELLER_REGISTRATION_SHORT_CODE_PATTERN = /^[A-Za-z0-9_-]{12}$/

const normalizeSellerRegistrationToken = (value: unknown) => {
  const token = String(value ?? '').trim()
  if (
    !token
    || token.length > 1024
    || (
      !SELLER_REGISTRATION_SIGNED_TOKEN_PATTERN.test(token)
      && !SELLER_REGISTRATION_SHORT_CODE_PATTERN.test(token)
    )
  ) return ''
  return token
}

const readSessionToken = () => {
  if (typeof window === 'undefined') return ''
  try {
    return normalizeSellerRegistrationToken(window.sessionStorage.getItem(SELLER_REGISTRATION_STORAGE_KEY))
  } catch {
    return ''
  }
}

const persistSessionToken = (token: string) => {
  if (typeof window === 'undefined') return
  try {
    if (token) {
      window.sessionStorage.setItem(SELLER_REGISTRATION_STORAGE_KEY, token)
    } else {
      window.sessionStorage.removeItem(SELLER_REGISTRATION_STORAGE_KEY)
    }
  } catch {
    // Storage can be unavailable in private browsing; the query string still works.
  }
}

export const getSellerRegistrationToken = (search?: string) => {
  const currentSearch = search ?? (typeof window !== 'undefined' ? window.location.search : '')
  const params = new URLSearchParams(currentSearch)
  const queryParam = params.has(SELLER_REGISTRATION_SHORT_QUERY_PARAM)
    ? SELLER_REGISTRATION_SHORT_QUERY_PARAM
    : params.has(SELLER_REGISTRATION_LEGACY_QUERY_PARAM)
      ? SELLER_REGISTRATION_LEGACY_QUERY_PARAM
      : ''
  if (queryParam) {
    const token = normalizeSellerRegistrationToken(params.get(queryParam))
    persistSessionToken(token)
    return token
  }
  return readSessionToken()
}

export const preserveSellerRegistrationSearch = (search?: string) => {
  const currentSearch = search ?? (typeof window !== 'undefined' ? window.location.search : '')
  const params = new URLSearchParams(currentSearch)
  const queryParam = params.has(SELLER_REGISTRATION_SHORT_QUERY_PARAM)
    ? SELLER_REGISTRATION_SHORT_QUERY_PARAM
    : params.has(SELLER_REGISTRATION_LEGACY_QUERY_PARAM)
      ? SELLER_REGISTRATION_LEGACY_QUERY_PARAM
      : ''
  if (!queryParam) return ''

  const token = normalizeSellerRegistrationToken(params.get(queryParam))
  if (!token) return ''
  persistSessionToken(token)

  const preserved = new URLSearchParams()
  preserved.set(queryParam, token)
  return `?${preserved.toString()}`
}

export const clearSellerRegistrationToken = () => persistSessionToken('')
